import BrandLogo from 'components/atoms/BrandLogo';
import { lineTotal } from 'utils/cartQuantity';

export const columns = [
  {
    title: 'product-name',
    dataIndex: 'arabic_name',
    width: '20%',
  },
  {
    title: 'brand',
    dataIndex: 'brand_image',
    className: 'brand-cell',
    render: (value, record) => <BrandLogo src={value} name={record.brand} />,
  },
  {
    title: 'country',
    dataIndex: 'country',
  },
  {
    title: 'remark',
    dataIndex: 'remark',
  },
  {
    title: 'price',
    dataIndex: 'price',
  },
  {
    title: 'quantity',
    dataIndex: 'quantity',
    isEditable: true,
    type: 'number',
  },
  {
    title: 'total',
    dataIndex: 'total',
    /* The figure on the row, through the same `lineTotal` the running total is
       kept by and the store recounts with - this was the last of the four
       places that worked it out for itself, which is how one of them came to
       floor the price and another not. */
    render: (_, record) => lineTotal(record).toLocaleString(),
  },
  {
    title: 'code',
    dataIndex: 'code',
  },
  {
    title: 'images',
    dataIndex: 'part_images',
    type: 'images',
    width: '20%',
  },
];
